{
  "en": {
    "fleetDashboard": {
      "showAll": "Show all",
      "empty": "Nothing here yet.",
      "failed": "This could not be loaded right now.",
      "unnamed": "Untitled",
      "formats": {
        "weekday": "EEE",
        "day": "d"
      },
      "activity": {
        "title": "Latest updates",
        "you": "You",
        "kinds": {
          "member_joined": "Joined the fleet",
          "event_published": "Event published",
          "event_cancelled": "Event cancelled",
          "contract_published": "Contract posted",
          "contract_claimed": "Contract claimed",
          "contract_fulfilled": "Contract fulfilled",
          "inventory_transfer_completed": "Transfer completed",
          "inventory_item_deposited": "Deposited",
          "inventory_item_withdrawn": "Withdrawn"
        },
        "empty": {
          "title": "Nothing has happened yet",
          "hint": "Published events and contracts land here, newest first."
        }
      },
      "events": {
        "title": "Upcoming events",
        "signUp": "Sign up",
        "empty": {
          "title": "Nothing planned for the next two weeks",
          "hint": "Check the events page for what is coming later.",
          "hintCreate": "Put an op on the calendar and members can sign up right away.",
          "action": "Plan an event"
        }
      },
      "actionQueue": {
        "title": "Needs your attention",
        "joinRequests": {
          "one": "%{count} request to join",
          "other": "%{count} requests to join"
        },
        "pendingTransfers": {
          "one": "%{count} incoming transfer to answer",
          "other": "%{count} incoming transfers to answer"
        },
        "partFailed": "Some of what needs you could not be loaded right now.",
        "empty": {
          "title": "All caught up",
          "hint": "Join requests and incoming transfers that need an answer show up here."
        },
        "memberHealth": {
          "one": "%{count} roster check needs attention",
          "other": "%{count} roster checks need attention"
        }
      },
      "contracts": {
        "title": "Contracts",
        "mine": "Your work",
        "open": "Open for pickup",
        "partFailed": "Some contracts could not be loaded right now.",
        "empty": {
          "title": "No open contracts",
          "hint": "Browse past work on the contracts board.",
          "hintCreate": "Post a job and members can pick it up.",
          "action": "Post a contract"
        }
      },
      "inventory": {
        "title": "Inventory",
        "empty": "No inventory movements lately.",
        "emptyMine": "Nothing of yours moved lately.",
        "emptyHint": "Deposits, withdrawals and transfers show up here.",
        "mine": "Mine",
        "fleet": "Fleet"
      },
      "newMembers": {
        "title": "New members",
        "empty": {
          "title": "Nobody new lately",
          "hint": "Members show up here once they have joined."
        }
      },
      "about": {
        "title": "About the fleet",
        "empty": {
          "title": "No description yet",
          "hint": "The fleet has not described itself yet.",
          "hintEdit": "Tell new members what the fleet is about.",
          "action": "Write one"
        }
      },
      "week": {
        "emptyDay": "Nothing on %{day}."
      },
      "online": {
        "title": "Online now (%{count})",
        "titlePending": "Online now",
        "friend": "Friend",
        "more": {
          "one": "and %{count} more",
          "other": "and %{count} more"
        },
        "empty": {
          "title": "Nobody else is online",
          "hint": "Members show up here as soon as they log in."
        }
      },
      "announcements": {
        "post": "Post an announcement",
        "postAction": "Post",
        "edit": "Edit announcement",
        "body": "Announcement",
        "until": "until %{date}",
        "confirmRemove": "Remove this announcement for everyone?",
        "expiry": {
          "label": "Show it",
          "keep": "Keep the current end",
          "never": "Until it is removed",
          "day": "For a day",
          "days3": "For three days",
          "week": "For a week",
          "weeks2": "For two weeks"
        },
        "messages": {
          "saved": "Announcement saved.",
          "saveFailed": "The announcement could not be saved.",
          "removed": "Announcement removed.",
          "removeFailed": "The announcement could not be removed."
        },
        "more": {
          "one": "Show %{count} more announcement",
          "other": "Show %{count} more announcements"
        }
      }
    }
  }
}
